import { render, staticRenderFns } from "./TituloTurmas.vue?vue&type=template&id=c5c4969e&"
import script from "./TituloTurmas.vue?vue&type=script&lang=js&"
export * from "./TituloTurmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports